export enum LeverageModel {
  Cross = 'Cross',
  Isolated = 'Isolated',
}

export enum LeverageDisplayMode {
  Position = 'Position',
  Actual = 'Actual',
}
